import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

// Components
import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';
import ListCoverPhoto from '../ListCoverPhoto';
import Link from '../Link';
import ListNotFound from '../../routes/listNotFound/ListNotFound';
import NotFound from '../../routes/notFound/NotFound';
import ToolTipSection from '../Common/ToolTipSection/ToolTipSection';

import { generateTime } from '../Receipt/helper';
import { formatTime } from '../../helpers/formatting';

// Locale
import messages from '../../locale/jsonMessages';
import { getDynamicName, getDynamicTitle } from '../../helpers/GetDynamicItemName/getDynamicName';

//Images
import Arrow from '/public/siteImages/rightSideArrow.svg';
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import starIcon from '/public/SiteIcons/star.svg';
import { dateFormat } from '../../config';
import { formatLocalizedDate } from '../../helpers/formatLocateDate';
import { getPromoCodeDetailsValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from '../../components/commonStyle.css';
import s from './Itinerary.css';


import OptionLines from '../ListingOptions/OptionLines';
import { getReservationOptionLines } from '../../helpers/bookingOptionsPresentation';
const Itinerary = (props) => {

  const { data } = props;
  const { formatMessage } = useIntl();
  const userId = useSelector(state => state?.account?.data?.userId)
  const locale = useSelector(state => state.intl.locale);
  const dynamicLanguageData = useSelector(state => state?.dynamicListSettings?.data);
  const dynamicListTitle = useSelector(state => state?.dynamicListTitles?.data?.dynamicListTitle)
  if (data === null) {
    return <> <FormattedMessage {...messages.errorMessage} /> </>;
  } else if (data.listData === null) {
    return <ListNotFound />;
  } else if (data.paymentState !== "completed") {
    return <NotFound />
  } else {
    const { data, data: { startTime, endTime, listTitle, id, listId, checkIn, checkOut, total, guestServiceFee, currency, confirmationCode, reservationState, hostId, guestId, basePrice, delivery, discount, discountType, dayDifference } } = props;
    const { data: { hostData: { profileId, firstName, picture, createdAt } } } = props;
    const { data: { listData: { title, street, city, state, country, zipcode } } } = props;
    const { data: { listData: { coverPhoto, listPhotos, reviewsCount, reviewsStarRating, settingsData, transmission } } } = props;
    const { data: { listData: { listingData: { checkInStart, checkInEnd } } } } = props;
    const { data: { messageData, securityDeposit, bookingSpecialPricing, messageThreadId } } = props;
    const { data: { promoCode, promoCodeDescription, promoDiscount, dynamicPromoCodeDetails } } = props;
    let carType, transmissionLabel, isSpecialPriceAssigned, checkInDate, checkOutDate, formattedStartTime, formattedEndTime;
    let checkInTime, checkOutTime, isAverage = 0, dayPrice = 0, isDayTotal = 0, threadsId, dynamicTitle;
    threadsId = messageThreadId?.id || messageData?.id

    carType = settingsData && settingsData.length > 0 && getDynamicName({ value: settingsData[0]?.listsettings, locale, data: dynamicLanguageData });


    dynamicTitle = getDynamicTitle({ data: dynamicListTitle, locale, id: listId });

    transmission == '1' ? transmissionLabel = formatMessage(messages.automatic) : transmissionLabel = formatMessage(messages.manual);
    isSpecialPriceAssigned = (bookingSpecialPricing && bookingSpecialPricing.length > 0) ? true : false;
    checkInDate = checkIn ? formatLocalizedDate(checkIn, locale, dateFormat?.longDateFormat) : '';
    checkOutDate = checkOut ? formatLocalizedDate(checkOut, locale, dateFormat?.longDateFormat) : '';

    if (isSpecialPriceAssigned) {
      bookingSpecialPricing && bookingSpecialPricing.map((item, index) => {
        dayPrice = dayPrice + Number(item.isSpecialPrice);
      });
    } else {
      dayPrice = basePrice * dayDifference;
    }


    if (checkInStart === 'Flexible') {
      checkInTime = formatMessage(messages.flexibleCheckIn);
    } else {
      checkInTime = generateTime(checkInStart, locale);
    }

    if (checkInEnd === 'Flexible') {
      checkOutTime = formatMessage(messages.flexibleCheckOut);
    } else {
      checkOutTime = generateTime(checkInEnd, locale);
    }

    let subTotal = basePrice * dayDifference;
    let subTotalWithSecurityDeposit = total + guestServiceFee + securityDeposit;
    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount)
    }

    let isHost = false;
    if (userId === hostId) {
      isHost = true;
    }

    formattedStartTime = formatTime(startTime, locale);
    formattedEndTime = formatTime(endTime, locale);

    let joinedDate = createdAt != null ? formatLocalizedDate(createdAt, locale, dateFormat?.monthYearFormat) : '';

    isAverage = Number(dayPrice) / Number(dayDifference);
    isDayTotal = isAverage.toFixed(2) * dayDifference;
    dayPrice = isDayTotal;

    const promoCodeDetails = JSON.parse(dynamicPromoCodeDetails || '[]');
    const dynamicValue = getPromoCodeDetailsValue(promoCodeDetails, locale);
    return (
      <Grid fluid className={s.container}>
        <Row className={cs.positionRelative}>
          <Col lg={7} sm={12} md={7} xs={12} className={cx(cs.spaceTop5, 'paymentDetailsPadding')}>
            {
              reservationState === "approved" && <h2 className={cx(cs.commonTitleText, cs.paddingBottom1, cs.fontWeightBold)}>
                <FormattedMessage {...messages.itineraryTitle} />
              </h2>
            }
            <h4 className={cx(cs.commonContentText, cs.fontWeightNormal)}>
              <FormattedMessage {...messages.confirmationCode} />{' '}
              <span>{'#'}{confirmationCode}</span>
            </h4>
            <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom4, cs.spaceTop4)} />
            {
              !isHost && <>
                <div className={cx(s.avatarImage, cs.paddingBottom4)}>
                  <Avatar
                    source={picture}
                    height={80}
                    width={80}
                    className={cs.profileAvatarLink}
                    withLink
                    profileId={profileId}
                  />
                  <div className={cx(s.textSection, 'viewListingTextSectionRTL')}>
                    <h5 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom1)}>
                      <FormattedMessage {...messages.hostedBy} />{' '}
                      <a href={"/users/show/" + profileId} target={'_blank'} className={cx(cs.reviewTitleLink, cs.commonContentText)}>
                        <span className={cs.siteLinkColor}>{firstName}</span>
                      </a>
                    </h5>
                    <h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.paddingBottom1)}><FormattedMessage {...messages.joinedIn} /> {joinedDate}</h6>
                    {messageData && <Link to={"/message/" + threadsId + "/renter"} className={cx(cs.siteLinkColor, cs.commonLinkBorderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                      <FormattedMessage {...messages.messageHost} />
                      <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                    </Link>}
                  </div>
                </div>
              </>
            }
            <div className={cx(s.boxSection, cs.spaceBottom4)}>
              <div className={cx(cs.dFlex, cs.flexWrap, cs.gap4, cs.paddingBottom3, cs.justifyContentSpaceBetween)}>
                <h4 className={cx(cs.commonTotalText, cs.fontWeightBold)}>
                  <FormattedMessage {...messages.billing} />
                </h4>
                <Link to={"/users/trips/receipt/" + id} className={cx(cs.siteLinkColor, cs.commonLinkBorderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                  <FormattedMessage {...messages.viewReceipt} />
                  <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </Link>
              </div>

              <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                <div className={cx(cs.commonSmallText16, cs.textStart)}>
                  <div className='tooltipFlex'>
                    {isSpecialPriceAssigned &&
                      <ToolTipSection label={formatMessage(messages.averageRate)}
                        tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
                    <div>
                      <CurrencyConverter amount={isAverage} from={currency} />
                      <span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
                    </div>
                  </div>
                </div>
                <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                  <CurrencyConverter amount={dayPrice} from={currency} />
                </div>
              </div>

              {discount > 0 &&
                <div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
                  <div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
                  <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                    <span>-&nbsp; <CurrencyConverter amount={discount} from={currency} /></span>
                  </div>
                </div>
              }

              {promoDiscount > 0 &&
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                  <div className={cx(cs.commonSmallText16, cs.textStart)}>
                    <div className="tooltipFlex">
                      <ToolTipSection label={dynamicValue.description ? dynamicValue?.description : promoCodeDescription} tooltipIconClass={cx(cs.positionRelative, cs.top3)} />
                      <span className='discountText'>{promoCode}</span>
                    </div>
                  </div>
                  <div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
                    <span>-&nbsp; <CurrencyConverter amount={promoDiscount} from={currency} /></span>
                  </div>
                </div>
              }

              <OptionLines lines={getReservationOptionLines(data)} currency={currency} titleMessage={messages.boIncluded} showLocation showContactNote />

              {guestServiceFee > 0 &&
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                  <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
                  <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                    <CurrencyConverter amount={guestServiceFee} from={currency} />
                  </div>
                </div>
              }

              {securityDeposit > 0 &&
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                  <div className={cx(cs.commonSmallText16, cs.textStart)}>
                    <FormattedMessage {...messages.securityDeposit} />
                  </div>
                  <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                    <CurrencyConverter amount={securityDeposit} from={currency} />
                  </div>
                </div>
              }

              <div className={cx(cs.dataTableGrid, cs.paymentDivider, cs.fontWeightBold)}>
                <div className={cx(cs.commonSmallText16, cs.textStart)}>
                  <FormattedMessage {...messages.totalPaid} />
                </div>
                <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                  <CurrencyConverter amount={subTotalWithSecurityDeposit} from={currency} />
                </div>
              </div>

            </div>
            <div className={s.boxSection}>
              <h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}>
                <FormattedMessage {...messages.tripDetails} />
              </h4>
              <div className={s.displayFlexDate}>
                <h5 className={cx(cs.commonContentText, cs.fontWeightBold)}>
                  <FormattedMessage {...messages.checkIn} />
                  <span className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.displayBlock, cs.paddingBottom1, cs.paddingTop2)}>{checkInDate}</span>
                  <span className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{formattedStartTime}</span>
                </h5>
                <img src={arrowIcon} className={cx(cs.dateArrowMargin, 'commonDateArrowRTLRotate')} />
                <h5 className={cx(cs.commonContentText, cs.fontWeightBold)}>
                  <FormattedMessage {...messages.checkOut} />
                  <span className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.displayBlock, cs.paddingBottom1, cs.paddingTop2)}>{checkOutDate}</span>
                  <span className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{formattedEndTime}</span>
                </h5>
              </div>
              <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
              <>
                <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}>
                  <FormattedMessage {...messages.location} />
                </h4>
                <h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>
                  <span>{street}, </span>
                  <span>{city}, {state}, {zipcode}</span>
                  <span>{' '}{country}.</span>
                </h6>
                <a href={"/cars/" + listId} target={'_blank'} className={cx(cs.siteLinkColor, cs.commonLinkBorderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                  <FormattedMessage {...messages.viewListing} />
                  <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </a>
              </>
            </div>
          </Col>
          <Col lg={5} md={5} sm={12} xs={12} className={cx(cs.spaceTop7, cs.paymentSticky)}>
            <div className={cx(s.imgBgColor, s.boxSection)}>
              <div className={cx(cs.positionRelative, cs.displayBlock)}>
                <a href={"/cars/" + listId} target={"_blank"}>
                  <ListCoverPhoto
                    className={cx(s.imageContent, cs.spaceBottom1)}
                    coverPhoto={coverPhoto}
                    listPhotos={listPhotos}
                    photoType={"x_medium"}
                    bgImage
                  />
                </a>
                <div className={cx(cs.positionAvatar, 'positionAvatarRTL', s.zIndex)}>
                  <Avatar
                    source={picture}
                    title={firstName}
                    className={cx(cs.profileAvatarLink, cs.profileAvatarLinkSmall)}
                    withLink
                    width={44}
                    height={44}
                    profileId={profileId}
                    linkClassName={cs.displayInlineBlock}
                  />
                </div>
              </div>
              <>
                <div className={cx(s.displayFlex, cs.spaceTop3)}>
                  <img src={steeringIcon} className={'commonIconSpace'} />
                  <h6 className={cx(cs.commonSmallText, cs.fontWeightNormal)}>
                    <span>{carType?.itemName}</span>
                    <span className={cs.dotCss}></span>
                    <span>{transmissionLabel}</span>
                  </h6>
                </div>
                <a href={"/cars/" + listId} target={"_blank"} className={cx(cs.spaceTop1, cs.commonContentText, cs.siteTextColor, cs.displayBlock, cs.fontWeightBold)}>
                  {dynamicTitle ? dynamicTitle : (listTitle ? listTitle : title)}
                </a>
                {starRatingValue > 0 && <div className={cx(cs.spaceTop1, cs.commonContentText, s.displayFlex)}>
                  <img src={starIcon} className={'searchHeaderIcon'} /> <span>{starRatingValue}</span>
                </div>}
              </>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}


Itinerary.propTypes = {
  formatMessage: PropTypes.any,
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    listId: PropTypes.number.isRequired,
    checkIn: PropTypes.string.isRequired,
    checkOut: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    guestServiceFee: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    confirmationCode: PropTypes.number.isRequired,
    reservationState: PropTypes.string.isRequired,
    listData: PropTypes.shape({
      title: PropTypes.string.isRequired,
      street: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      zipcode: PropTypes.string.isRequired,
      reviewsCount: PropTypes.number.isRequired,
      reviewsStarRating: PropTypes.number.isRequired,
      listingData: PropTypes.shape({
        checkInStart: PropTypes.string.isRequired,
        checkInEnd: PropTypes.string.isRequired
      }),
      coverPhoto: PropTypes.number,
      listPhotos: PropTypes.arrayOf({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      }),
    }),
    messageData: PropTypes.shape({
      id: PropTypes.number.isRequired
    }),
    hostData: PropTypes.shape({
      profileId: PropTypes.number.isRequired,
      firstName: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired
    })
  })
};

Itinerary.defaultProps = {
  data: null
};

export default withStyles(cs, s)(Itinerary);
